<template>
  <div class="reset-pass">
    <div :class="['content']">
      <h1>找回密码</h1>
      <t-message v-show="isToastshow" theme="error" icon :duration="2000" :content="message" />
      <div class="tab-check">
        <p :class="[istabCheck == 1 ? 'p1' : 'p2']" @click="changeTab(1)">
          手机找回
        </p>
        <p :class="[istabCheck == 2 ? 'p1' : 'p2']" @click="changeTab(2)">
          邮箱找回
        </p>
      </div>

      <PhoneRetrieve v-if="resetPassType == 1" @setresetPassType="setresetPassType" @toLogin="toLogin"
        :referUrl="referUrl"></PhoneRetrieve>

      <EmailRetrieve v-else @setresetPassType="setresetPassType" @toLogin="toLogin" :referUrl="referUrl"></EmailRetrieve>
    </div>
    <!--滑块验证-->
    <slider-verify ref="sliderVerify" @closeDialog="closeDialog" @success="onSuccess" @again="onAgain" />
  </div>
</template>

<script>
import { getQueryString, zhugeTrack } from "@/utils/utils";
import PhoneRetrieve from "@/components/reset-pass/phoneRetrieve";
import EmailRetrieve from "@/components/reset-pass/emailRetrieve";
import sliderVerify from "@/components/common/puzzleVerify";
import { mapState, mapMutations } from "vuex";
export default {
  name: "reset-pass",

  data() {
    return {
      resetPassType: 1,
      referUrl: "",
      codeLogin: "",
      istabCheck: 1,
    };
  },
  components: {
    PhoneRetrieve,
    EmailRetrieve,
    sliderVerify
  },
  mounted() {
    // 获取登录页跳转的页面
    this.referUrl = getQueryString("refer")
      ? decodeURIComponent(getQueryString("refer"))
      : "";
    // 是否是回车课堂登录页
    this.codeLogin = getQueryString("codeLogin");
    zhugeTrack("进入_找回密码页",{
      终端:"Web"
    });
  },
  computed: {
    ...mapState(["isToastshow", "message", "manyloginToast", "isShowSliderVerify"]),
  },
  methods: {
    ...mapMutations(["toastshow", "toastHidden", "manyLoginToastshow"]),
    changeTab(value) {
      this.resetPassType = value;
      this.istabCheck = value;
    },
    setresetPassType(type) {
      // this.resetPassType = type;
    },
    toLogin() {
      this.$router.push({
        name: "login",
        query: {
          refer: this.referUrl ? this.referUrl : undefined,
          codeLogin: this.codeLogin ? this.codeLogin : undefined,
        },
      });
    },
    onSuccess() {},
    /* 滑动验证异常*/
    onAgain() {
      this.$message.error("滑动操作异常，请重试")
    },
    closeDialog() {},
  },
  metaInfo() {
    return {
      title: window.location.search.indexOf('match')>-1?'忘记密码 - 传智杯大赛官网-全国大学生计算机应用能力与数字素养大赛':'忘记密码 - 博学谷·黑马程序员线上品牌',
      meta: [
        {
          name: "keyWords",
          content: "找回密码,入口,学习中心,账号,登录,密码,找回,博学谷",
        },
        {
          name: "description",
          content:
            "博学谷找回密码入口，学员忘记学习账号登录密码，可以通过此入口重置密码，找回登录密码后可以重新登录学习账号，在线学习所报名的视频课程或视频教程，如找回密码失败可咨询客服老师或拨打客服电话：010-5628 8220。",
        },
      ],
      link: [{ rel: "icon", type: "image/x-icon", href: window.location.search.indexOf('match')>-1?'/favicon.czb.ico':'/favicon.ico' }]
    };
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1280px) {
  .content {
    right: 120px !important;
  }
}

@media screen and (min-width: 1920px) {
  .content {
    right: 440px !important;
  }
}

@media screen and (min-width: 1281px) and (max-width: 1919px) {
  .content {
    right: 200px !important;
  }
}

.reset-pass {
  ::v-deep input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px white inset !important;
  }

  .t-message {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -24px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #1d2129;
    width: max-content;
    height: 48px;
    background: #ffffff;
    box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08),
      0px 3px 6px -4px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    border: 1px solid #e5e6eb;
  }

  .contentheight1 {
    height: 520px;
  }

  .contentheight2 {
    height: 660px !important;
  }

  .content {
    width: 464px;
    height: 520px;
    background: #ffffff;
    box-shadow: 0px 12px 40px 16px rgba(8, 25, 93, 0.03),
      0px 8px 20px 0px rgba(8, 25, 93, 0.06),
      0px 4px 8px 0px rgba(8, 25, 93, 0.08);
    border-radius: 8px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 200px;
    box-sizing: border-box;

    h1 {
      height: 32px;
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1d2129;
      line-height: 32px;
      margin: 48px auto 24px;
      text-align: center;
    }

    .tab-check {
      display: flex;
      padding-left: 48px;
    }

    .p1 {
      height: 24px;
      border-radius: 4px 4px 0px 0px;
      margin-right: 32px;
      line-height: 24px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 600;
      color: #165dff;
      cursor: pointer;

      &::after {
        content: "";
        width: auto;
        height: 3px;
        background: #165dff;
        border-radius: 4px 4px 0px 0px;
        display: block;
        margin-top: 7px;
      }
    }

    .p2 {
      height: 24px;

      cursor: pointer;
      border-radius: 4px 4px 0px 0px;
      margin-right: 32px;
      line-height: 24px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;

      color: #4e5969;

      &:hover {
        color: #165dff;
      }
    }
  }

  //     .el-input__inner {
  //       width: 368px;
  //       height: 40px;
  //       background: rgba(255, 255, 255, 0.9);
  //       border-radius: 4px;
  //       line-height: 41px;

  //       padding-left: 16px;
  //       box-sizing: border-box;
  //       border: 1px solid #e5e6eb;
  //       &:focus {
  //         border: 1px solid $btnColor;
  //       }
  //     }
  //        ::v-deep .code-from {
  //       margin-top: 33px;
  //  .el-form-item {
  //       margin-bottom: 24px !important;
  //     }
  //       .el-input__inner {
  //          width: 368px;
  //       height: 40px;
  //       background: rgba(255, 255, 255, 0.9);
  //       border-radius: 4px;
  //       line-height: 41px;

  //       padding-left: 16px;
  //       box-sizing: border-box;
  //       border: 1px solid #e5e6eb;
  //       &:focus {
  //         border: 1px solid #4080FF;
  //       }
  //       }
  //       .is-error {
  //         .el-input__inner {
  //           border: 1px solid #ff4012;
  //         }
  //         .el-form-item__error {
  //           color: #ff4012;
  //         }
  //       }
  // }
  ::v-deep .code-from {
    margin-top: 33px;

    .el-form-item {
      margin-bottom: 24px;
    }

    .el-input__inner {
      width: 368px;
      height: 40px;
      background: rgba(255, 255, 255, 0.9);
      border-radius: 4px;
      line-height: 40px;
      padding-left: 16px;
      box-sizing: border-box;
      border: 1px solid #e5e6eb;

      &:focus {
        border: 1px solid #4080ff;
      }
    }

    .is-error {
      .el-input__inner {
        border: 1px solid #ff4012;
      }

      .el-form-item__error {
        color: #ff4012;
        padding-top: 0px;
        height: 20px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #f53f3f;
        line-height: 20px;
      }
    }
  }
}
</style>
